import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { NameFormBase } from '../../FormBases';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  error: FieldError | undefined;
};

/**
 * 新規登録モーダル用の顧客名のフォームです。
 */
export const NameForm: FC<Props> = ({ register, error }) => (
  <FormControl isRequired isInvalid={Boolean(error)}>
    <FormLabel>顧客名</FormLabel>
    <NameFormBase register={register} />
    <FormErrorMessage>{error && error.message}</FormErrorMessage>
  </FormControl>
);
